<template>
  <v-dialog
    :fullscreen="isMobileBreakpoint"
    v-model="openModal"
    persistent
    max-width="800"
    class="pa-3"
  >
    <v-card class="py-3" style="display: flex; flex-direction: column">
      <v-toolbar elevation="0" class="pl-3">
        <v-toolbar-title class="text--subtitle" style="display: grid">
          <span class="body-bold-medium neutral-20-dark--text">
            {{ $t('message.playlists.titleAddVideoPlaylist') }}
          </span>
          <span class="body-regular-smaller neutral-40-light--text">
            {{ selectedVideos.length }}
            {{ $t('message.playlists.videosSelected') }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text style="flex: 1; height: 100%">
        <template v-if="arrayPlaylist.length > 0">
          <BaseAlert
            v-if="userLibrary.block_none_refer && !enableDomain"
            class="mb-8"
            type="warning"
            :title="$t('message.playlists.titleBlockedDomain')"
            :description="$t('message.playlists.subtitleBlockedDomain')"
          >
            <base-btn
              style="background: #fff"
              @click="handleAddRefer"
              size="small"
              type="secondary"
              >{{ $t('message.actions.add') }}</base-btn
            ></BaseAlert
          >
          <v-col
            :cols="isMobileBreakpoint || isTabletBreakpoint ? 12 : 'auto'"
            :order="isMobileBreakpoint || isTabletBreakpoint ? 'first' : ''"
            class="ml-auto d-flex justify-space-between align-center mr-4 mb-5"
          >
            <SearchBar
              class="search-bar"
              v-show="!isMobileBreakpoint"
              :list="arrayPlaylist"
              :fuseOptions="searchFuseOptions"
              :placeholder="
                $t('message.pages.videosDataTable.searchBar.placeholder')
              "
              @filterList="($value) => (filterList = $value)"
            />
            <span class="body-regular-smaller textType6--text"
              >{{ arrayPlaylist.length }} Itens</span
            >
          </v-col>
          <v-card
            flat
            width="100%"
            class="data-table__header mb-2"
            ref="dataTableHeader"
          >
            <v-row no-gutters style="height: 24px">
              <v-col
                cols="8"
                class="d-flex align-center justify-start"
                style="margin-left: 30px"
              >
                <v-row no-gutters>
                  <v-hover v-slot="{ hover }">
                    <div class="d-flex align-center" @click="handleOrderByName">
                      <span
                        class="body-label-xs caption-title neutral-20-dark--text mr-1"
                      >
                        Playlist
                      </span>
                      <v-icon v-if="hover && !nameOrder" class="menuIcon"
                        >mdi-menu-down</v-icon
                      >
                      <v-icon
                        v-if="hover && nameOrder === 'desc'"
                        class="menuIcon"
                        >mdi-menu-down</v-icon
                      >
                      <v-icon
                        v-if="hover && nameOrder === 'asc'"
                        class="menuIcon"
                        >mdi-menu-up</v-icon
                      >
                    </div>
                  </v-hover>
                </v-row>
              </v-col>
              <v-col class="d-flex align-center justify-start">
                <v-row no-gutters>
                  <v-hover v-slot="{ hover }">
                    <div class="d-flex align-center" @click="handleOrderByName">
                      <span class="caption-title mr-1">
                        {{ $t('message.playlists.columnsHeader.access') }}
                      </span>
                      <v-icon v-if="hover && !nameOrder" class="menuIcon"
                        >mdi-menu-down</v-icon
                      >
                      <v-icon
                        v-if="hover && nameOrder === 'desc'"
                        class="menuIcon"
                        >mdi-menu-down</v-icon
                      >
                      <v-icon
                        v-if="hover && nameOrder === 'asc'"
                        class="menuIcon"
                        >mdi-menu-up</v-icon
                      >
                    </div>
                  </v-hover>
                </v-row>
              </v-col>
              <v-col class="d-flex align-center justify-start">
                <v-row no-gutters>
                  <v-hover v-slot="{ hover }">
                    <div class="d-flex align-center" @click="handleOrderByName">
                      <span class="caption-title mr-1"> Vídeos </span>
                      <v-icon v-if="hover && !nameOrder" class="menuIcon"
                        >mdi-menu-down</v-icon
                      >
                      <v-icon
                        v-if="hover && nameOrder === 'desc'"
                        class="menuIcon"
                        >mdi-menu-down</v-icon
                      >
                      <v-icon
                        v-if="hover && nameOrder === 'asc'"
                        class="menuIcon"
                        >mdi-menu-up</v-icon
                      >
                    </div>
                  </v-hover>
                </v-row>
              </v-col>
              <v-col class="d-flex align-center justify-start">
                <v-row no-gutters>
                  <v-hover v-slot="{ hover }">
                    <div class="d-flex align-center" @click="handleOrderByName">
                      <span class="caption-title mr-1">
                        {{ $t('message.playlists.columnsHeader.duration') }}
                      </span>
                      <v-icon v-if="hover && !nameOrder" class="menuIcon"
                        >mdi-menu-down</v-icon
                      >
                      <v-icon
                        v-if="hover && nameOrder === 'desc'"
                        class="menuIcon"
                        >mdi-menu-down</v-icon
                      >
                      <v-icon
                        v-if="hover && nameOrder === 'asc'"
                        class="menuIcon"
                        >mdi-menu-up</v-icon
                      >
                    </div>
                  </v-hover>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
          <vue-virtual-table
            v-if="arrayPlaylist.length > 0"
            ref="dataTableContent"
            class="data-table__content"
            :class="{ virtualTable: $vuetify.theme.dark }"
            :config="tableConfig"
            :data="arrayPlaylist"
            :height="300"
            :itemHeight="48"
            :minWidth="650"
            style="position: relative; z-index: 1"
          >
            <template slot-scope="scope" slot="selectCommon">
              <v-row
                no-gutters
                justify="center"
                class="data-index"
                align="center"
                style="max-width: 10px"
                :data-index="scope.index"
              >
                <v-simple-checkbox
                  color="primary"
                  :ripple="false"
                  :value="checkIfSelected(scope.row)"
                  @input="checkboxSelection(scope.row)"
                />
              </v-row>
            </template>
            <template slot-scope="scope" slot="titleCommon">
              <v-row
                no-gutters
                align="center"
                style="max-width: 100%"
                class="video-row"
              >
                <simple-svg
                  :src="require('@/assets/pandaIcons/playlist.svg')"
                  fill-class-name="fill-color"
                  :fill="
                    $vuetify.theme.dark
                      ? 'var(--brand-70-dark)'
                      : 'var(--brand-70-light)'
                  "
                  width="16px"
                />
                <div>
                  <template>
                    <span
                      :title="scope.row.name"
                      class="body-regular-small neutral-20-dark--text mt-2"
                    >
                      {{ scope.row.name }}
                    </span>
                  </template>
                </div>
              </v-row>
            </template>
            <template slot-scope="scope" slot="accessCommon">
              <v-row
                no-gutters
                align="center"
                style="max-width: 100%"
                class="video-row"
              >
                <v-tooltip v-if="scope.row.access == 'public'" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs"
                      ><simple-svg
                        v-on="on"
                        v-bind="attrs"
                        :src="require('@/assets/pandaIcons/key.svg')"
                        fill-class-name="fill-color"
                        :fill="
                          $vuetify.theme.dark
                            ? 'var(--neutral-40-light-dark)'
                            : 'var(--neutral-40-light-light)'
                        "
                        width="16px"
                    /></span>
                  </template>
                  <span>{{ $t('message.playlists.tooltipAccessKey') }}</span>
                </v-tooltip>
                <v-tooltip v-else bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-on="on" v-bind="attrs"
                      ><simple-svg
                        v-on="on"
                        v-bind="attrs"
                        :src="require('@/assets/pandaIcons/link.svg')"
                        fill-class-name="fill-color"
                        :fill="
                          $vuetify.theme.dark
                            ? 'var(--neutral-40-light-dark)'
                            : 'var(--neutral-40-light-light)'
                        "
                        width="16px"
                    /></span>
                  </template>
                  <span>{{ $t('message.playlists.tooltipAccessLink') }}</span>
                </v-tooltip>
              </v-row>
            </template>
            <template slot-scope="scope" slot="videosCommon">
              <v-row
                no-gutters
                align="center"
                style="max-width: 100%"
                class="video-row"
              >
                <div class="ml-2">
                  <template>
                    <span :title="scope.row.title" class="text-truncate mt-2">
                      {{ scope.row.videos_quantity }}
                    </span>
                  </template>
                </div>
              </v-row>
            </template>
            <template slot-scope="scope" slot="durationCommon">
              <v-row
                no-gutters
                align="center"
                style="max-width: 100%"
                class="video-row"
              >
                <div class="ml-2">
                  <template>
                    <span :title="scope.row.title" class="text-truncate mt-2">
                      {{ formatDuration(scope.row.duration) }}
                    </span>
                  </template>
                </div>
              </v-row>
            </template>
          </vue-virtual-table>
        </template>
        <template v-else>
          <v-container class="empty__container mt-8" fill-height>
            <v-row
              class="d-flex flex-column"
              no-gutters
              justify="center"
              align="center"
            >
              <img
                class="emptyStateTitle mb-4"
                src="@/assets/emptyPlaylist.svg"
                max-width="240"
              />
              <span class="body-regular-large neutral-20-dark--text">
                {{ $t('message.playlists.descriptionCreatePlaylist') }}
              </span>
              <span class="body-regular-small neutral-40-light--text">
                {{ $t('message.playlists.subtitleCreatePlaylist') }}
              </span>
              <base-btn class="mt-7" size="small">
                <span @click="openCreatePlaylist">{{
                  $t('message.createPlaylistBtn')
                }}</span>
              </base-btn>
            </v-row>
          </v-container>
        </template>
      </v-card-text>

      <v-divider v-if="arrayPlaylist.length > 0" />
      <v-card-actions
        v-if="arrayPlaylist.length > 0"
        class="pl-4 pr-6 pb-4 pt-6"
      >
        <base-btn type="neutral" @click="openCreatePlaylist">
          <span class="brand-60-base--text">{{
            $t('message.createPlaylistBtn')
          }}</span></base-btn
        >
        <v-spacer v-if="!isMobileBreakpoint"></v-spacer>
        <base-btn @click="closeModal" type="tertiary mr-2">{{
          $t('message.actions.cancel')
        }}</base-btn>
        <v-tooltip bottom :disabled="selectedItems.length">
          <template v-slot:activator="{ on, attrs }">
            <base-btn
              v-on="on"
              v-bind="attrs"
              type="primary"
              :disabled="!selectedItems.length"
              @click="publishPlaylist"
              >{{ $t('message.actions.publish') }}</base-btn
            >
          </template>
          <span>{{ $t('message.playlists.tooltipSelectedPlaylist') }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueVirtualTable from 'vue-virtual-table'
import SearchBar from '@/components/SearchBar.vue'
import referApi from '@/services/referApi.js'
import { mapState, mapMutations } from 'vuex'
import BaseAlert from '@/components/BaseAlert.vue'
import playlistApi from '../services/playlistApi'
export default {
  name: 'AddVideoPlaylistModal',
  components: {
    SearchBar,
    VueVirtualTable,
    BaseAlert,
  },
  props: {
    openModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    selectedVideos: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    arrayPlaylist: [],
    selectedItems: [],
    enableDomain: false,
    domainsPanda: [
      {
        hostname: 'pandavideo.com.br',
        type: 'ALLOW',
      },
      {
        hostname: 'playlist-staging.tv.pandavideo.com',
        type: 'ALLOW',
      },
      {
        hostname: 'playlist.tv.pandavideo.com',
        type: 'ALLOW',
      },
    ],
    tableHeight: 300,
    userLibrary: {},
    refers: [],
    nameOrder: 'asc',
    accessOrder: 'asc',
    durationOrder: 'asc',
    videosOrder: 'asc',
    filterList: 'all',
    searchFuseOptions: {
      keys: ['title', 'name', 'description'],
      includeScore: true,
      threshold: 0.4,
    },
  }),
  computed: {
    ...mapState('user', {
      planInfo: 'userPlanInfo',
      mainVideos: 'mainVideos',
      subFolderVideos: 'subFolderVideos',
      deletedFolders: 'deletedFolders',
      isTabletBreakpoint: 'isTabletBreakpoint',
      isMobileBreakpoint: 'isMobileBreakpoint',
      userFirstAccess: 'userFirstAccess',
      isRecapAvailable: 'isRecapAvailable',
      isPandaBrandingActive: 'isPandaBrandingActive',
      isDrmActive: (state) => state.drmData.isDrmActive,
      drmGroupsLoading: (state) => state.drmData.loadings.drmGroups,
      drmGroups: (state) => state.drmData.drmGroups,
    }),
    tableConfig() {
      const tableConfig = [
        {
          prop: '_action',
          name: 'action',
          actionName: 'selectCommon',
          width: 20,
          alignItems: 'end',
        },
        {
          prop: '_action',
          name: 'action',
          actionName: 'titleCommon',
          width: 260,
          alignItems: 'start',
        },
        {
          prop: '_action',
          name: 'action',
          actionName: 'accessCommon',
          width: 43,
          alignItems: 'start',
        },
        {
          prop: '_action',
          name: 'action',
          actionName: 'videosCommon',
          width: 27,
          alignItems: 'start',
        },

        {
          prop: '_action',
          name: 'action',
          actionName: 'durationCommon',
          width: 40,
          alignItems: 'start',
        },
      ]

      return tableConfig
    },
    anyItemSelected() {
      return this.selectedItems.length > 0
    },
    checkboxIndeterminateStatus() {
      return (
        this.selectedItems.length > 0 &&
        this.selectedItems.length < this.arrayPlaylist.length
      )
    },
  },
  watch: {
    async openModal(newVal) {
      if (newVal) await this.loadPlaylistFromLocalStorage()
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async getUserLibrary() {
      try {
        let ret = await referApi.getLibrary()
        this.userLibrary = ret.data
      } catch (e) {
        console.log(e)
      }
    },
    setTableHeight() {
      const getEl = (target) => document.querySelector(target)

      const actions = getEl('.data-table__actions')
      const header = getEl('.data-table__header')
      const content = getEl('.page-view__content')
      const line = getEl('.item-line')

      const aHeight = actions?.clientHeight || 65
      const hHeight = header?.clientHeight || 45
      const cHeight = content?.clientHeight || 600
      const lHeight = line?.clientHeight || 48

      const cPaddingTop = window
        .getComputedStyle(content, null)
        .getPropertyValue('padding-top')

      const differ = aHeight + hHeight - parseInt(cPaddingTop, 10)

      this.tableHeight = Math.abs(
        cHeight - differ - ((cHeight - differ) % lHeight)
      )
    },
    selectAllItems() {
      let arr = []

      if (this.selectedItems.length !== this.arrayPlaylist.length) {
        arr = [...this.arrayPlaylist]
      }

      this.selectedItems = arr
    },
    handleOrderByName() {
      if (!this.nameOrder || this.nameOrder === 'desc')
        return (this.nameOrder = 'asc')
      if (this.nameOrder === 'asc') return (this.nameOrder = 'desc')
    },
    async loadPlaylistFromLocalStorage() {
      try {
        const storedData = await playlistApi.getPlaylists()
        this.arrayPlaylist = storedData.data
      } catch (error) {
        console.error('Erro ao carregar dados do localStorage:', error)
        this.arrayPlaylist = []
      }
    },

    closeModal() {
      this.selectedItems = []
      this.$emit('update:openModal', false)
      this.openModal = false
    },
    openCreatePlaylist() {
      this.$emit('update:createPlaylist', true)
      this.closeModal()
    },
    checkIfSelected(item) {
      return this.selectedItems.some((selected) => selected.id === item.id)
    },
    checkboxSelection(item) {
      const alreadySelected = this.checkIfSelected(item)
      if (alreadySelected) {
        this.selectedItems = this.selectedItems.filter(
          (selected) => selected.id !== item.id
        )
      } else {
        this.selectedItems.push(item)
      }
    },
    handleClickRow(item) {
      this.checkboxSelection(item)
    },
    formatDuration(seconds) {
      if (seconds <= 0) {
        return '00:00'
      }

      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const remainingSeconds = Math.floor(seconds % 60)

      return hours > 0
        ? `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
            2,
            '0'
          )}:${String(remainingSeconds).padStart(2, '0')}`
        : `${String(minutes).padStart(2, '0')}:${String(
            remainingSeconds
          ).padStart(2, '0')}`
    },
    publishPlaylist() {
      try {
        const _this = this
        const selectedVideosIds = this.selectedVideos.map((video, index) => {
          return {
            video_id: video.id,
            order: index,
          }
        })
        this.arrayPlaylist.forEach(async (playlist) => {
          const isPlaylistSelected = _this.selectedItems.some(
            (selected) => selected.id === playlist.id
          )
          if (isPlaylistSelected) {
            const videos = await playlistApi.updatePlaylistVideos(
              selectedVideosIds,
              playlist.id
            )
            if (videos) this.UPDATE_PLAYLIST(videos)
          }
        })
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.$t('message.playlists.toastAddVideo'),
          type: 'success',
        })
        this.closeModal()
      } catch (error) {
        console.error('Erro ao salvar a playlist:', error)
      }
    },
    getAccessClass(access) {
      return access === 'public' ? 'green--text' : 'red--text'
    },
    async getRefers() {
      const getRefers = await referApi.getRefers(this.userLibrary.id)
      this.refers = getRefers.data.refers
      const urlRefers = this.refers.map((row) => row.url)
      const domainsFiltered = this.domainsPanda.filter((domain) =>
        urlRefers.includes(domain.hostname)
      )
      if (domainsFiltered.length == 3) this.enableDomain = true
    },
    async handleAddRefer() {
      try {
        await referApi.addMultipleRefers(this.userLibrary.id, this.domainsPanda)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.$t('message.embedModal.snackBarSuccess'),
          type: 'success',
        })
        this.enableDomain = true
      } catch (err) {
        console.log(err)
      }
    },
  },
  async mounted() {
    await this.getUserLibrary()
    await this.loadPlaylistFromLocalStorage()
    if (this.userLibrary.block_none_refer) await this.getRefers()
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/src/data-tableV2';
.fill-brand-70 {
  fill: varFigma(brand-70);
}
.caption-title {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
.search-bar {
  &::v-deep {
    .v-input {
      margin-bottom: 0px !important;
    }
  }
}
::v-deep .data-table__header > .row {
  border-bottom: unset;
}
::v-deep .item-line {
  border-top: 1px solid varFigma(neutral-95-lightest) !important;
}
.data-table__content {
  &::v-deep {
    .t-container {
      width: 100% !important;
    }
  }
}
</style>
